import { Link } from "@mui/material";

export const ProjectLinkCell = ({
  id,
  name,
}: {
  id: string | undefined;
  name: string | undefined;
}) => {
  if (!name && !id) return <span>-</span>;
  if (!id) return <span>{name}</span>;

  return (
    <Link href={`/projects/${id}`} rel="noopener noreferrer" target="_blank">
      {name ?? id}
    </Link>
  );
};
